import { QuoteInfo } from "../../models/models";
import { RestService } from "../../services/rest.service";
import { getEmptyQuote } from './Quote';
import { getEmptyStore } from './Store';

export function getQuoteInfo(rest:RestService): QuoteInfo
{
		return {
			quote: getEmptyQuote(rest),
			client_user:null,
			creator: null,
			store: getEmptyStore(),
			items: [],
			order: null,
			responses: [],
			attachments: [],
		}
}
